<template>
  <div class="product-container">
    <div class="product-container-in">
      <ProductHeader v-model="form.development_status" @handlerClick="handlerClick"></ProductHeader>
      <div class="product-container-list">
        <Left :params="form.development_status" v-model="form.product_series_id"></Left>
        <Right :params="form" v-if="form.product_series_id"></Right>
      </div>
    </div>
  </div>
</template>
<script>
import ProductHeader from './header'
import Left from './left'
import Right from './right'

export default {
  components: { ProductHeader, Left, Right },
  data() {
    return {
      form: {
        development_status: 0,
        product_series_id: ''
      },
    }
  },
  created() {
    let { development_status, product_series_id } = this.$route.query
    if (product_series_id) {
      this.form = {
        development_status: development_status ? Number(development_status) : 0,
        product_series_id: product_series_id ? Number(product_series_id) : ''
      }
    }
  },
  watch: {
    form: {
       handler() {
        this.changeUrl(this.form)
      },
      deep: true,
    }
  },
  methods: {
    changeUrl(obj) {
      var url = window.location.href
      var params = new URLSearchParams(window.location.search);
      for(let key in obj) {
        params.set(key, obj[key]);
      }
      var newUrl = url.split('?')[0]+ '?'+ params.toString();
      window.history.pushState({},'',newUrl);
    },
    handlerClick() {
      this.$router.push('/productDataAdd?product_series_id=' + this.form.product_series_id)
    }
  }
}
</script>
<style lang="scss">
.product-container {
  display: flex;
  flex: 1;
  justify-content: center;
  background-color: #F5F5F5;
  .el-loading-mask {
    background-color: #F5F5F5;
  }
  .product-container-in {
    display: flex;
    flex-direction: column;
    width: 1465px;
  }
  .product-container-list {
    height: 0;
    flex: 1;
    overflow: hidden;
    display: flex;
  }
}
</style>
